module.exports = __webpack_public_path__ + "img/electricity-usage.e45676e3.png";